// Betreiber-Globalsicht auf die Nachweiskette (GET /admin/audit) — alle Mandanten inkl. plattformweiter
// Betreiber-Aktionen (Werkstatt-Spalte „Plattform"), optional auf eine Werkstatt gefiltert. Der Server
// erzwingt requireSuperadmin; Guard-Wrapper hier, damit Nicht-Betreiber keine 403-Requests auslösen.
import { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'
import { localDayKey } from '@wf/shared'
import { useAuth } from '../app/auth'
import { monthRange } from '../zeiten/timeMath'
import { MonthNav } from '../zeiten/MonthNav'
import { AuditQueryState } from '../protokoll/AuditQueryState'
import { AuditTable } from '../protokoll/AuditTable'
import { useAdminAudit } from '../protokoll/useAudit'
import { useAdminWorkshops } from './useAdmin'

export function AdminAuditPage() {
  const { user } = useAuth()
  if (!user) return null
  if (!user.isSuperadmin) return <Navigate to="/overview" replace />
  return <AdminAuditContent />
}

function AdminAuditContent() {
  const [month, setMonth] = useState(() => localDayKey(Date.now()).slice(0, 7))
  const [workshopId, setWorkshopId] = useState<number | undefined>(undefined)
  const { from, to } = monthRange(month)
  const audit = useAdminAudit(from, to, workshopId)
  const workshops = useAdminWorkshops()

  const entries = audit.data?.entries ?? []

  return (
    <section className="wf-view">
      <div className="wf-viewhead">
        <div>
          <h2 className="viewtitle">Protokoll (alle Werkstätten)</h2>
          <p className="sub">Globale Nachweiskette inkl. Betreiber-Aktionen — revisionssicher, append-only.</p>
        </div>
        <Link className="wf-btn wf-btn--ghost wf-btn--sm" to="/admin">
          ← App-Verwaltung
        </Link>
      </div>

      <MonthNav month={month} onChange={setMonth}>
        <select
          className="wf-input"
          aria-label="Werkstatt filtern"
          value={workshopId ?? ''}
          onChange={(e) => setWorkshopId(e.target.value === '' ? undefined : Number(e.target.value))}
        >
          <option value="">Alle Werkstätten</option>
          {(workshops.data?.workshops ?? []).map((w) => (
            <option key={w.id} value={w.id}>
              {w.name}
            </option>
          ))}
        </select>
      </MonthNav>

      <AuditQueryState isLoading={audit.isLoading} isError={audit.isError} truncated={audit.data?.truncated ?? false} narrowHint="Zeitraum oder Werkstatt-Filter" />
      {audit.data ? <AuditTable entries={entries} withWorkshop /> : null}
    </section>
  )
}
